import { observer } from 'mobx-react';
import { LicenseFamily } from '../../../../Organization/Types';
import ParticipantStore from '../../../../ParticipantStore';
import ParticipantsStore from '../../../../ParticipantsStore';
import Row from './Row';

interface Props {
  store: ParticipantsStore;
  participantStores: ReadonlyArray<ParticipantStore>;
  licenseFamily: LicenseFamily;
}

function Body({ participantStores, licenseFamily }: Props) {
  return (
    <tbody className="divide-y divide-gray-200 bg-white">
      {participantStores.map((participantStore) => (
        <Row
          store={participantStore}
          key={participantStore.resource.payload.id}
          licenseFamily={licenseFamily}
        />
      ))}
    </tbody>
  );
}

export default observer(Body);
